/** Human-scale steel personnel door; its scale is intentionally hostile to Rosalie. */
import * as THREE from 'three';
import { surface } from '../materials';
import type { AssetDefinition } from '../types';

function build(): THREE.Group {
  const group = new THREE.Group();
  group.name = 'hall-door';
  const steel = surface('metal', 0x778384);
  const panel = new THREE.Mesh(new THREE.BoxGeometry(0.9, 2, 0.055), steel);
  panel.name = 'door-leaf'; panel.position.set(0, 1, 0); panel.castShadow = true; group.add(panel);
  for (const [x, y, width, height, name] of [
    [-0.47, 1.04, 0.08, 2.08, 'frame-left'], [0.47, 1.04, 0.08, 2.08, 'frame-right'],
    [0, 2.04, 1.02, 0.08, 'frame-head'],
  ] as const) {
    const frame = new THREE.Mesh(new THREE.BoxGeometry(width, height, 0.1), surface('metal', 0x626f70));
    frame.name = name; frame.position.set(x, y, -0.01); frame.castShadow = true; group.add(frame);
  }
  const kick = new THREE.Mesh(new THREE.BoxGeometry(0.78, 0.22, 0.012), surface('metal', 0xaeb6b5));
  kick.name = 'kick-plate'; kick.position.set(0, 0.14, 0.034); group.add(kick);
  const handleBase = new THREE.Mesh(new THREE.CylinderGeometry(0.035, 0.035, 0.025, 10), surface('metal', 0xb9c1c0));
  handleBase.name = 'handle-rose'; handleBase.rotation.x = Math.PI / 2; handleBase.position.set(0.27, 1.05, 0.048); group.add(handleBase);
  const lever = new THREE.Mesh(new THREE.CylinderGeometry(0.016, 0.016, 0.14, 8), surface('metal', 0xb9c1c0));
  lever.name = 'lever-handle'; lever.rotation.z = Math.PI / 2; lever.position.set(0.34, 1.05, 0.065); group.add(lever);
  return group;
}

export const hallDoorAsset: AssetDefinition = {
  id: 'hall-door', label: 'Hall door', description: 'Full-size 0.9 by 2.0 m steel personnel door with kick plate and 1.05 m lever.',
  footprint: { width: 1.02, height: 2.08, length: 0.13 }, create: build,
};
